const getStatusPriority = (status) => {
  if (status === "completed") {
    return 1;
  }

  return 0;
};

const getRequestTimestamp = (request) => {
  const parsed = Date.parse(request?.created_at ?? "");
  return Number.isNaN(parsed) ? null : parsed;
};

export const normalizeRequestRow = (row) => {
  if (!row) {
    return null;
  }

  const tableId = row.table?.id ?? row.table_id ?? null;
  const tableName = row.table?.name ?? null;

  return {
    ...row,
    table: tableId || tableName
      ? {
          id: tableId,
          name: tableName,
        }
      : null,
  };
};

export const sortRequestsForUi = (rows) =>
  [...rows].sort((left, right) => {
    const statusDiff =
      getStatusPriority(left?.status) - getStatusPriority(right?.status);

    if (statusDiff !== 0) {
      return statusDiff;
    }

    const leftTimestamp = getRequestTimestamp(left);
    const rightTimestamp = getRequestTimestamp(right);

    if (leftTimestamp !== rightTimestamp) {
      if (leftTimestamp === null) {
        return 1;
      }

      if (rightTimestamp === null) {
        return -1;
      }

      return rightTimestamp - leftTimestamp;
    }

    const leftId = Number(left?.id ?? 0);
    const rightId = Number(right?.id ?? 0);

    return rightId - leftId;
  });

export const normalizeRequestRows = (rows) =>
  sortRequestsForUi((rows ?? []).map(normalizeRequestRow).filter(Boolean));

export const getRequestTableLabel = (request) => {
  const tableName = request?.table?.name;
  if (tableName) {
    return tableName;
  }

  const tableId = request?.table?.id ?? request?.table_id ?? null;
  if (tableId !== null && tableId !== undefined) {
    return `Masa #${tableId}`;
  }

  return "Masa bilgisi güncelleniyor";
};
